import { render } from "./AiFavorableCommentsDetails.vue?vue&type=template&id=469608f7&scoped=true"
import script from "./AiFavorableCommentsDetails.vue?vue&type=script&lang=js"
export * from "./AiFavorableCommentsDetails.vue?vue&type=script&lang=js"

import "./AiFavorableCommentsDetails.vue?vue&type=style&index=0&id=469608f7&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469608f7"]])

export default __exports__